var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"home"}},[_c('Header',{staticClass:"home-header"}),_c('div',{attrs:{"id":"content"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }